import { configureStore } from '@reduxjs/toolkit';

import course from 'store/modules/course/course-slice';
import category from 'store/modules/category/category-slice';
import progression from 'store/modules/progression/progression-slice';
import quest from 'store/modules/quest/quest-slice';
import subquest from 'store/modules/subquest/subquest-slice';
import report from 'store/modules/report/report-slice';
import subQuestReport from 'store/modules/subQuestReport/subQuest-report-slice';
import learningPlan from 'store/modules/learningPlan/learningPlan-slice';
import learningPlanCourse from 'store/modules/learningPlanCourse/learningPlanCourse-slice';
import classRedux from 'store/modules/class/class-slice';
import publishEntity from 'store/modules/common/publishEntity/publishEntity-slice';
import user from 'store/modules/user/user-slice';

// import adminGrowthStage from 'modules/admin/growthStage/store/admin-growthstage-slice';
import companionSlice from 'companion/store/companion-slice';
import ui from './modules/ui-slice';

const store = configureStore({
  reducer: {
    ui: ui.reducer,
    companion: companionSlice.reducer,
    course: course.reducer,
    category: category.reducer,
    progression: progression.reducer,
    quest: quest.reducer,
    subquest: subquest.reducer,
    report: report.reducer,
    subQuestReport: subQuestReport.reducer,
    learningPlan: learningPlan.reducer,
    learningPlanCourse: learningPlanCourse.reducer,
    class: classRedux.reducer,
    publishEntity: publishEntity.reducer,
    user: user.reducer,
    // adminGrowthStage: adminGrowthStage.reducer,
  },
});

export default store;
